import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ErrorPopup } from "@shared/ui/modals/error/error-popup.component";
import { SuccessPopup } from "@shared/ui/modals/success/success-popup.component";

@Injectable({
    providedIn:'root'
})
export class PopupService{

    constructor(private readonly dialog:MatDialog){
        
    }
    success(message:string,submessage:string){
        return this.dialog.open(SuccessPopup,{
          width:'660px',
          height:'300px',
          data:{message,submessage}
        });
      }
    
      error(message:string,submessage:string){
        return this.dialog.open(ErrorPopup,{
          width:'660px',
          height:'294px',
          data:{message,submessage}
        });
      }
    
}